// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-card-header {
  margin-bottom: 15px;
  margin-left: -10px;
  margin-right: -10px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 10px;
  border-bottom: 1px solid 0 0 0 1;
  display: flex;
  align-items: center;
}
.nkl-card-header-title {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  font-weight: bold;
}
.nkl-card-header-right {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
